package songwritersnotebook.app.utils

import songwritersnotebook.app.data.UserProfile
import songwritersnotebook.app.getPlatform
import dev.gitlive.firebase.Firebase
import dev.gitlive.firebase.firestore.FieldValue
import dev.gitlive.firebase.firestore.firestore
import kotlinx.datetime.Clock

object CreditService {

    private val db = Firebase.firestore
    private const val USERS_COLLECTION = "users"

    suspend fun awardDailyCredits(userId: String, tier: String) {
        val creditsToAward = when (tier) {
            "STUDIO" -> 100
            else -> 0
        }

        if (creditsToAward > 0) {
            val userRef = db.collection(USERS_COLLECTION).document(userId)
            try {
                val nowLong = Clock.System.now().toEpochMilliseconds()
                val isJs = getPlatform().name.contains("Web", ignoreCase = true)
                val now: Any = if (isJs) nowLong.toDouble() else nowLong

                val updates = mapOf<String, Any>(
                    "aiCreditsDaily" to creditsToAward,
                    "lastDailyCreditReset" to now
                )
                userRef.update(updates)
                println("CreditService: Awarded $creditsToAward daily credits to user $userId")
            } catch (e: Exception) {
                println("CreditService: Error awarding daily credits to user $userId: $e")
            }
        }
    }

    suspend fun addOneTimeCredits(userId: String, creditsToAdd: Int) {
        if (creditsToAdd > 0) {
            val userRef = db.collection(USERS_COLLECTION).document(userId)
            try {
                // mapOf("field" to value) is standard for update
                val updates = mapOf<String, Any>("aiCreditsOneTime" to FieldValue.increment(creditsToAdd))
                userRef.update(updates)
                println("CreditService: Added $creditsToAdd one-time credits to user $userId")
            } catch (e: Exception) {
                println("CreditService: Error adding one-time credits to user $userId: $e")
            }
        }
    }

    suspend fun useAiCredits(userId: String, amount: Int): Boolean {
        val userRef = db.collection(USERS_COLLECTION).document(userId)
        try {
            val snapshot = userRef.get()
            // Using data() which reified to UserProfile
            val userProfile: UserProfile = snapshot.data()

            val totalCredits = userProfile.totalAiCredits
            if (totalCredits < amount) {
                return false
            }

            var remainingToDeduct = amount
            val dailyCreditsDeducted: Int
            val oneTimeCreditsDeducted: Int

            if (userProfile.aiCreditsDaily >= remainingToDeduct) {
                dailyCreditsDeducted = remainingToDeduct
                oneTimeCreditsDeducted = 0
                remainingToDeduct = 0
            } else {
                dailyCreditsDeducted = userProfile.aiCreditsDaily
                remainingToDeduct -= userProfile.aiCreditsDaily
                oneTimeCreditsDeducted = remainingToDeduct
            }

            val updates = mapOf<String, Any>(
                "aiCreditsDaily" to FieldValue.increment(-dailyCreditsDeducted),
                "aiCreditsOneTime" to FieldValue.increment(-oneTimeCreditsDeducted)
            )
            userRef.update(updates)
            return true

        } catch (e: Exception) {
            println("CreditService: Error using AI credits for user $userId: $e")
            return false
        }
    }
}
